/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
import PropTypes from 'prop-types';
import React from 'react';

import FieldForm from 'Component/FieldForm';
import GdprConsent from 'Component/GdprConsent';
import Link from 'Component/Link';
import MyAccountConfirmIdForm from 'Component/MyAccountConfirmIdForm/MyAccountConfirmIdForm.container';
import { CUSTOMER_TYPES } from 'Component/MyAccountCreateAccount/MyAccountCreateAccount.config';
import { GROUP_ID_EMPLOYEE, GROUP_ID_PRO } from 'Route/MyAccount/MyAccount.config';
import { CustomerType } from 'Type/Account.type';
import transformToNameValuePair from 'Util/Form/Transform';

import './MyAccountDocumentsForm.style';

/** @namespace PeggysagePwa/Component/MyAccountDocumentsForm/Component */
export class MyAccountDocumentsFormComponent extends FieldForm {
    static propTypes = {
        customer: CustomerType.isRequired,
        onSave: PropTypes.func.isRequired,
        onChangeFile: PropTypes.func.isRequired,
        uploadStepList: PropTypes.arrayOf(PropTypes.shape({
            code: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            strings: PropTypes.objectOf(PropTypes.string)
        }))
    };

    onFormSuccess = this.onFormSuccess.bind(this);

    onFormSuccess(form, fields) {
        const { onSave } = this.props;

        onSave(transformToNameValuePair(fields));
    }

    canRenderComponent() {
        const {
            uploadStepList,
            customer: {
                group_id: customerGroupId = 0
            }
        } = this.props;

        if (uploadStepList && customerGroupId && (customerGroupId === GROUP_ID_EMPLOYEE || customerGroupId === GROUP_ID_PRO)) {
            const filteredStepList = uploadStepList.filter((upload) => upload.code !== 'carte_identite');
            return filteredStepList.length !== 0;
        }

        return true;
    }

    renderValidateIdentitySection() {
        const {
            uploadStepList,
            customer,
            customer: {
                group_id: customerGroupId = 0
            },
            onChangeFile
        } = this.props;

        if (!uploadStepList || !uploadStepList.length || !this.canRenderComponent()) {
            return null;
        }

        // eslint-disable-next-line no-nested-ternary
        const customerType = customerGroupId === GROUP_ID_PRO ? CUSTOMER_TYPES.pro : customerGroupId === GROUP_ID_EMPLOYEE ? CUSTOMER_TYPES.employee : CUSTOMER_TYPES.student;

        return uploadStepList.map((file) => (
            <div
              block="FieldForm"
              elem="Section"
              mix={ { block: 'FieldForm', elem: 'SectionWithSpace', className: 'identity' } }
              key={ file.code }
            >
                <legend block="FieldForm" elem="Legend">
                    { file.title }
                </legend>
                { !!customer[file.code] && (
                    <div block="FieldForm" elem="CurrentFile">
                        <Link
                          block="FieldForm"
                          elem="CurrentFileLink"
                          to={ customer[file.code] }
                          target="_blank"
                        >
                            { __('View current file') }
                        </Link>
                    </div>
                ) }
                <MyAccountConfirmIdForm
                  customerType={ customerType }
                  fileType={ file.code }
                  formStrings={ file.strings }
                  onChangeFile={ onChangeFile }
                  isSkipDisabled
                  isSubmitDisabled
                />
            </div>
        ));
    }

    renderGdprField() {
        if (!this.canRenderComponent()) {
            return null;
        }

        return (
            <GdprConsent
              location="registration"
              mix={ { block: 'MyAccountDocuments', elem: 'Checkbox' } }
            />
        );
    }

    renderActions() {
        if (!this.canRenderComponent()) {
            return null;
        }

        return (
            <div block="FieldForm" elem="Actions">
                <button
                  type="submit"
                  block="Button"
                  mix={ { block: 'MyAccountDocuments', elem: 'Submit' } }
                >
                    { __('Update') }
                </button>
            </div>
        );
    }

    getFormProps() {
        return {
            onSubmit: this.onFormSuccess,
            mix: {
                block: 'MyAccountDocumentsForm',
                className: 'FieldForm'
            }
        };
    }

    renderFormBody() {
        return (
            <div block="FieldForm" elem="Body">
                <div block="FieldForm" elem="Fields">
                    { this.renderValidateIdentitySection() }
                    { this.renderGdprField() }
                </div>
                { this.renderActions() }
            </div>
        );
    }
}

export default MyAccountDocumentsFormComponent;
